export const RSS_CATEGORY = 'post';